import Vue from 'vue';
import Vuex from 'vuex';

import loading from './loading';
import user from './user';
import breadcrumb from './breadcrumb';
import configurationData from './configurationData';
import getters from './getters';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: { loading, user, configurationData, breadcrumb },
  getters
});
